import React, { useEffect, useState } from "react";
import SectionTitle from "../components/section-title";
import Usertable from "../components/usertable";
import Widget from "../components/widget";
import ApiClient from "../apis/apiClient";
import { API_DeleteProspectById, API_GetAllProspects } from "../apis/constant";
import { Redirect } from "react-router-dom";
import "nprogress/nprogress.css";
import moment from "moment";
import CsvDowloader from "../components/CsvDowloader";
import { checkAccess } from "../utils/common";
import Modal2 from "./../components/confirm-delete-modal/modal-2";
import { FiX } from "react-icons/fi";
import { toast } from "react-toastify";

const Simple = () => {
  const [usersData, setUsersData] = useState([]);
  const [Loading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [paginationObject, setPaginationObject] = useState({});
  const adminToken = localStorage.getItem("wed_admin_token");

  const getAllUsers = async (limit, pageNumber) => {
    const data = "";
    setIsLoading(true);
    // setIsApiCall(true);
    const res = await ApiClient.get(
      API_GetAllProspects +
        `?page=${pageNumber}&limit=${limit}&searchBy=${search}`, //page number
      data,
      `Bearer ${adminToken}`,
    );
    if (res.data.code === 200) {
      const data = res.data.data.docs ?? [];
      if (res.data.data && data.length !== 0) {
        for (let i = 0; i < data.length; i++) {
          data[i].createdAt = moment(data[i].createdAt).format("DD-MMM-YYYY");
          data[i].reminderSentAt = data[i].reminderSentAt
            ? moment(data[i].reminderSentAt).format("DD-MMM-YYYY hh:mm A")
            : "";
          data[i].isInfluencer = data[i].isInfluencer ? "✔️" : "❌";
          data[i].registered = data[i].registered ? "✔️" : "❌";
        }
      }
      setPaginationObject({
        limit: res.data.data.limit,
        page: res.data.data.page,
        pages: res.data.data.pages,
        total: res.data.data.total,
      });

      const _dataTemp = data.map((item, index) => {
        return {
          ...item,
          no: res.data.data.total - (pageNumber - 1) * limit - index,
        };
      });
      setUsersData(_dataTemp);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (search.length > 2 || search.length === 0) {
      getAllUsers(10, 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const deleteProspect = async (prospect) => {
    const id = prospect.original.id;
    const data = "";
    const res = await ApiClient.delete(
      API_DeleteProspectById + id,
      data,
      `Bearer ${adminToken}`,
    );
    if (res.data?.code === 200) {
      toast.success(res.data?.message);
    } else {
      toast.error(res.data?.message);
    }
    toast.success("Prospect deleted successfully");
    getAllUsers(10, 1);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "No",
        accessor: "no",
      },
      {
        Header: "User Email",
        accessor: "userEmail",
      },
      {
        Header: "Ref Code",
        accessor: "refCode",
      },
      {
        Header: "Ref Unique Code",
        accessor: "referrerId.userUniqueId",
      },
      {
        Header: "Is Influencer",
        accessor: "isInfluencer",
      },
      {
        Header: "Registered",
        accessor: "registered",
      },
      {
        Header: "Ref Code When Registered",
        accessor: "refCodeWhenRegistered",
      },
      {
        Header: "User Id (if registered)",
        accessor: "userId.userUniqueId",
      },
      {
        Header: "Created At",
        accessor: "createdAt",
      },
      {
        Header: "Reminder Count",
        accessor: "reminderSent",
      },
      {
        Header: "Last Reminder Sent",
        accessor: "reminderSentAt",
      },
      {
        Header: "Action",
        id: "delete",
        accessor: (str) => {},
        show: false,
        Cell: (Datatable) => (
          <>
            {checkAccess(3, "delete") && (
              <Modal2
                title="Delete"
                icon={
                  <span className="h-10 w-10 bg-red-100 text-white flex items-center justify-center rounded-full text-lg font-display font-bold">
                    <FiX size={18} className="stroke-current text-red-500" />
                  </span>
                }
                body={
                  <div className="text-sm text-grey-500">
                    Are You Sure! You want to delete this User?
                  </div>
                }
                buttonTitle="Confirm"
                onClick={() => {
                  deleteProspect(Datatable.row);
                }}
                buttonClassName="underline"
              />
            )}
          </>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const getPageData = (data, type) => {
    if (type === "limit") {
      getAllUsers(data, 1);
    } else {
      getAllUsers(data, 1);
    }
  };

  const data = React.useMemo(() => usersData, [usersData]);
  if (adminToken === null) {
    return <Redirect to="/" />;
  } else {
    return (
      // <div style={{ overflowX: "auto" }}>
      <div>
        <div className="w-full flex items-center gap-2">
          <input
            className="searchCss"
            type="text"
            placeholder="Search By Email Or Ref Code"
            value={search}
            // onChange={(e) => handleSearchData(e.target.value)}
            onChange={(e) => setSearch(e.target.value)}
          />
          <CsvDowloader columns={columns} data={data} filename="customers" />
        </div>
        <Usertable
          columns={columns}
          data={data}
          loading={Loading}
          pagination={paginationObject}
          onSubmit={getPageData}
          showSearch={true}
          getAllUsers={getAllUsers}
        />
      </div>
    );
  }
};

const Index = () => (
  <>
    <SectionTitle title="" subtitle="Prospects" />
    <Widget>
      <Simple />
    </Widget>
  </>
);
export default Index;
